import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.bulk-verification-result', {
        url: '/bulk-verification-result',
        params: {importedUsers: null},
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsBulkVerificationResult'
        },
        resolve: {importedUsers},
    });
}

/** @ngInject */
function importedUsers($stateParams) {
    return $stateParams.importedUsers;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/bulk-verification-result/bulk-verification-result.state.js